// src/main.ts
import { initializeHeader } from "./components/header/header.ts";
import { initializeTabs } from "./components/tabs/tabs.ts";
import { initializeFindCars } from "./components/find-cars/find-cars.ts";
import { initializeNotifications } from "./components/toast/toast";
import { initializeSavedCars } from "./components/saved-cars/saved-cars";

// Initialize all modules when page loads
document.addEventListener("DOMContentLoaded", async () => {
  initializeHeader();
  initializeNotifications();
  initializeTabs();
  initializeFindCars();
  initializeSavedCars();
});
